module.exports = __webpack_public_path__ + "img/parcoursup-2025.65342d1.png";